<template lang="pug">
  div(class="expedient-invoices")
    GridTableComponent(
      ref="grid"
      v-if="!showAddInvoice && gridColumns"
      :itemsData="listItems"
      :gridConfiguration="gridColumns"
      :title="title"
      :toolbarOptions="customToolbarOptions"
      :contextMenuItems="gridContextMenuItems"
      :listName="listName"
      :context="invoiceContext"
      :showHeader="false"
      :disabledContextMenuBeforeOpen="false"
      :customToolbarContextMenuItems="invoicesContextMenuItems"
      @cellClicked="onCellClicked"
      @contextMenuBeforeOpen="onContextMenuBeforeOpen"
      @contextMenuClicked="onContextMenuClicked"
      @toolbarClicked="onToolbarClicked"
      @customToolbarContextMenuClick="onInvoiceAddClick"
      :commandClick="onCommandClick"
    )

    TemplateSelectorComponent(
      :showDialog="showTemplateDialog"
      :idEntityType="idEntityType"
      @closeTemplateDialog="closeTemplateDialog"
      @generateTemplateDialog="generateTemplateDialog"
    )

    FacturaEDialog(
      v-if="getShowFacturaEDialog"
      :key="getFacturaEDialogKey"
      :showDialog="showFacturaEDialog"
      :invoiceId="getSelectedInvoiceId"
      :invoiceDescription="getSelectedInvoiceDescription"
      :invoiceTemplates="hasProfessionalFacturaETemplate"
      @closeDialog="closeFacturaEDialog"
    )
</template>

<script lang="ts">
import { Component, Mixins, Prop } from 'vue-property-decorator'
import { Action, Getter, Mutation } from 'vuex-class'
import GridTableComponent from '@/components/grids/GridTable/GridTableComponent.vue'
import { Icons } from '@/icons/icons'
import { ContextName, ModuleNamespaces } from '@/store/types/storeGlobalTypes'
import { Entity, entity, entityKeyFields } from '@/store/modules/entities/entitiesTypes'
import { Endpoint } from '@/store/modules/endpoint/endpointTypes'
import { CustomDialogComponentName, CustomDialogData, DialogTypes } from '@/store/modules/dialog/dialogTypes'
import PrintInvoiceContextMenuMixin from '@/mixins/PrintInvoiceContextMenuMixin.vue'
import { getUrlByIdEntity, redirectTo } from '@/helpers/routes'
import TemplateSelectorComponent from '@/components/template/TemplateSelectorComponent/TemplateSelectorComponent.vue'
import { ComponentWhereIsRendered } from '@/store/modules/alerts/alertsTypes'
import { ExpedientCustomerFact } from '@/store/modules/expedients/expedientsTypes'
import GridContextMenuOptionsMixin from '@/mixins/GridContextMenuOptionsMixin.vue'
import { InvoiceTypesNames } from '@/store/modules/invoices/invoicesTypes'
import { InvoiceEntityId } from '@/general/entityIds'
import {
  ActionName,
  CommandClickEventArgs,
  CommandModel,
  GridConfiguration
} from '@/components/grids/LfGrid/LfGridTypes'
import { gridConfigurationWithActionColumn } from '@/helpers/grid'
import {
  columnsChooserToolbarItem,
  kebakMenuToolbarItem,
  searchToolbarItem,
  filterToolbarItem
} from '@/components/grids/LfGrid/components/ToolbarContextMenu/ToolbarContextMenuType'
import { TrackerEvents, trackEvent } from '@/plugins/tracker'
import FacturaEDialog from '@/components/billing/FacturaEDialog/FacturaEDialog.vue'
import { FacturaEStatusEnum } from '@/store/modules/facturaE/facturaETypes'
import { NoFacturaEStatusEnum } from '@/store/modules/facturaE/noFacturaETypes'
import { isTrue } from '@/helpers/boolean'

const authModule = ModuleNamespaces.AUTH
const configurationModule: string = ModuleNamespaces.CONFIGURATION
const endpointModule: string = ModuleNamespaces.ENDPOINT
const entitiesModule: string = ModuleNamespaces.ENTITIES
const expedientsModule = ModuleNamespaces.EXPEDIENTS
const listItemsModule = ModuleNamespaces.LIST_ITEMS
const selectedRegisterModule: string = ModuleNamespaces.SELECTED_REGISTER
const dialogModule = ModuleNamespaces.DIALOG

@Component({
  components: {
    GridTableComponent,
    TemplateSelectorComponent,
    FacturaEDialog
  }
})
export default class ExpedientInvoicesComponent extends Mixins(
  PrintInvoiceContextMenuMixin,
  GridContextMenuOptionsMixin
) {
  @Prop({
    type: Number,
    required: true
  })
  expedientId!: string

  @Prop({
    type: Object,
    default: () => {}
  })
  columns!: GridConfiguration

  @Prop({
    type: String,
    default: ''
  })
  title!: string

  @Prop({
    type: String,
    default: ''
  })
  listName!: string

  @Prop({
    type: Boolean,
    default: false
  })
  showGrid!: boolean

  @Prop({
    type: [Array, Object],
    required: true
  })
  itemsData!: []

  @Prop({
    type: Boolean,
    default: false
  })
  showFilters!: boolean

  @Action('createEntity', { namespace: entitiesModule })
  createEntity: ({}) => Promise<void>

  @Action('saveSelectedRegisterId', { namespace: selectedRegisterModule })
  saveSelectedRegisterId: ({}) => Promise<void>

  @Action('deleteRegister', { namespace: selectedRegisterModule })
  deleteInvoice: ({}) => Promise<void>

  @Action('fetchCurrentListConfiguration', { namespace: configurationModule })
  fetchCurrentListConfiguration: (alias: string) => Promise<void>

  @Action('showCustomDialog', { namespace: dialogModule })
  showCustomDialogAction: ({}: CustomDialogData) => {}

  @Mutation('REMOVE_LIST_ITEMS', { namespace: listItemsModule })
  removeListItems: () => Promise<[]>

  @Mutation('SAVE_EXPEDIENT_CUSTOMER_FACT', { namespace: expedientsModule })
  saveExpedientCustomerFactMutation: (expedientCustomerFact: ExpedientCustomerFact) => void

  @Getter('getEntity', { namespace: entitiesModule })
  entity: (context: string) => Entity

  @Getter('getEndpoints', { namespace: endpointModule })
  endpoints: (entityType: number) => Endpoint

  @Getter('getSelectedRegisterId', { namespace: selectedRegisterModule })
  selectedRegisterId: (context: string) => any

  @Getter('getListItemsWithFormattedDates', { namespace: listItemsModule })
  listItems: object

  @Getter('getCurrentListConfiguration', { namespace: configurationModule })
  listConfiguration: object

  @Getter('getCompanyTemplateInvoices', { namespace: authModule })
  hasCompanyTemplateInvoice: boolean

  @Getter('getSelectedRegisterData', { namespace: selectedRegisterModule })
  selectedRegisterData: (context: string) => {}

  entityType: number = 0

  showAddInvoice: boolean = false
  idEntityType: number = entity.invoices.customers.type
  idEntity: number = 0

  invoiceContext = ContextName.EXPEDIENT_INVOICES

  icons = {
    addNew: Icons.ADD,
    invoice: Icons.BILL
  }

  numberInvoice: string = ''
  idInvoice: string = ''
  descriptionInvoice: string = ''
  professionalFacturaETemplate: boolean = false

  facturaEDialogKey: number = 0
  showFacturaEDialog: boolean = false

  get customToolbarOptions() {
    return [
      searchToolbarItem,
      filterToolbarItem,
      ...(this.userHasPermissionToInvoiceAtLeastOneInvoiceType
        ? [
            {
              id: 'customToolbarContextMenu',
              text: this.$t('components.grid_table.tooltip.new_invoice'),
              tooltipText: this.$t('components.grid_table.tooltip.new_invoice'),
              cssClass: 'lf-btn-model2',
              align: 'Right',
              contextMenuItems: this.invoicesContextMenuItems
            }
          ]
        : []),
      columnsChooserToolbarItem,
      kebakMenuToolbarItem
    ]
  }

  get gridColumns() {
    if (!this.columns) {
      return ''
    }
    const config = this.columns
    const commandButtons: CommandModel[] = [
      {
        id: ActionName.OPEN_KEBAK_MENU,
        type: 'None',
        title: 'Open',
        buttonOption: {
          iconCss: Icons.KEBAB,
          cssClass: 'custombutton'
        }
      }
    ]
    const gridConfiguration = gridConfigurationWithActionColumn(config, commandButtons)
    return JSON.stringify(gridConfiguration)
  }

  get invoicesContextMenuItems() {
    const invoiceTypes = [
      { type: entity.invoices.orderForms.type, text: this.$t('components.context_menu.order_form') },
      { type: entity.invoices.proforma.type, text: this.$t('navigation.drawer-menu-items.invoice_proforma') },
      { type: entity.invoices.customers.type, text: this.$t('navigation.drawer-menu-items.invoice_customer') },
      { type: entity.invoices.providers.type, text: this.$t('navigation.drawer-menu-items.invoice_provider') }
    ]

    return invoiceTypes
      .filter((invoiceType) => this.checkEntityPermissionsGetter(invoiceType.type).canSave)
      .map((invoiceType) => ({
        text: invoiceType.text,
        iconCss: this.icons.invoice,
        idEntity: invoiceType.type
      }))
  }

  get gridContextMenuItems() {
    const { openWindow, editItem, lookItem, removeItem, sendFacturaE } = this.contextMenuOptionsTexts
    const { canSave } = this.checkEntityPermissionsGetter(InvoiceEntityId.CUSTOMER_INVOICES)

    const items = this.isPortalUser
      ? [{ iconCss: Icons.OPEN_WINDOW, text: openWindow }]
      : [
          { text: editItem, iconCss: Icons.EDIT },
          { iconCss: Icons.OPEN_WINDOW, text: openWindow },
          ...(canSave
            ? [{ iconCss: Icons.DOCUMENT_VALIDATE, text: sendFacturaE, action: this.showFacturaEDialog }]
            : []),
          { text: lookItem, iconCss: Icons.VISIBLE },
          { text: removeItem, iconCss: Icons.REMOVE, action: this.showDialog }
        ]

    return items
  }

  get getViewActionsDetailContextMenuItem() {
    const { viewActionsAssociated } = this.contextMenuOptionsTexts
    return { text: viewActionsAssociated, iconCss: Icons.CLOCK }
  }

  get getShowFacturaEDialog(): boolean {
    return this.showFacturaEDialog
  }
  get getFacturaEDialogKey(): number {
    return this.facturaEDialogKey
  }

  get getSelectedInvoiceId(): number {
    return parseInt(this.idInvoice, 10) || 0
  }

  get getSelectedInvoiceDescription(): string {
    return this.descriptionInvoice
  }

  get hasProfessionalFacturaETemplate(): boolean {
    return this.professionalFacturaETemplate
  }

  created() {
    this.invoiceContext = ContextName.EXPEDIENT_INVOICES
  }

  async onCellClicked(selectedRegister: any, cancel: boolean) {
    trackEvent(TrackerEvents.EDIT_INVOICE)
    if (!cancel && !this.isPortalUser) {
      cancel = true
      this.invoiceRedirect(selectedRegister)
      const urlInvoice = getUrlByIdEntity(selectedRegister.idEntity, selectedRegister.idInvoice)
      redirectTo(urlInvoice)
    }
  }

  onContextMenuBeforeOpen(contextMenuModule: any, contextMenuGridObject: any, selectedRegister: any) {
    const selectedContactTypePermission = this.checkEntityPermissionsGetter(selectedRegister.idEntity)
    const { canSave } = selectedContactTypePermission

    this.renderEditOrLookOptionInContextMenu(contextMenuModule, contextMenuGridObject, canSave)
    const { editItem, viewActionsAssociated } = this.contextMenuOptionsTexts

    contextMenuModule.removeItems([viewActionsAssociated])
    contextMenuGridObject.removeItems([viewActionsAssociated])
    if (
      selectedRegister.type.toString().toLowerCase() === InvoiceTypesNames.CUSTOMER.toLowerCase() &&
      selectedRegister.hasAction
    ) {
      contextMenuModule.insertAfter([this.getViewActionsDetailContextMenuItem], editItem, false)
      contextMenuGridObject.insertAfter([this.getViewActionsDetailContextMenuItem], editItem, false)
    }

    this.toggleDeleteMenuOption(contextMenuModule, contextMenuGridObject, selectedRegister)
    this.toggleFacturaEMenuOption(contextMenuModule, contextMenuGridObject, selectedRegister)
  }

  setMenuItemVisibility(
    contextMenuModule: any,
    contextMenuGridObject: any,
    menuItem: string,
    isVisible: boolean
  ): void {
    if (isVisible) {
      contextMenuModule.showItems([menuItem])
      contextMenuGridObject.showItems([menuItem])
    } else {
      contextMenuModule.hideItems([menuItem])
      contextMenuGridObject.hideItems([menuItem])
    }
  }

  toggleDeleteMenuOption(contextMenuModule: any, contextMenuGridObject: any, selectedRegister: any) {
    const { canDelete } = this.checkEntityPermissionsGetter(selectedRegister.idEntity)
    const { removeItem } = this.contextMenuOptionsTexts

    const allowedStatuses: string[] = [
      FacturaEStatusEnum.DRAFT,
      FacturaEStatusEnum.ERROR,
      NoFacturaEStatusEnum.NOT_APPLY
    ]

    const isValidStatus: boolean = isTrue(allowedStatuses.includes(selectedRegister?.statusFacturaE) && canDelete)
    this.setMenuItemVisibility(contextMenuModule, contextMenuGridObject, String(removeItem), isValidStatus)
  }

  toggleFacturaEMenuOption(contextMenuModule: any, contextMenuGridObject: any, selectedRegister: any) {
    const { sendFacturaE } = this.contextMenuOptionsTexts

    const allowedStatuses: string[] = [FacturaEStatusEnum.DRAFT, FacturaEStatusEnum.ERROR]
    const isValidStatus = allowedStatuses.includes(selectedRegister?.statusFacturaE)

    this.setMenuItemVisibility(contextMenuModule, contextMenuGridObject, String(sendFacturaE), isValidStatus)
  }

  getEntityAlias(entityType: number) {
    const selectedEntity = Object.values(entity.invoices).find((entity: any) => entity.type === entityType)
    return (selectedEntity as any).alias
  }

  async onContextMenuClicked(args: any, selectedRegister: any) {
    this.numberInvoice = selectedRegister.numberInvoice
    this.idInvoice = selectedRegister.idInvoice
    this.descriptionInvoice = selectedRegister.description
    this.professionalFacturaETemplate = isTrue(selectedRegister?.professionalConfig?.facturaETemplate)
    const { openWindow, editItem, lookItem, removeItem, viewActionsAssociated, sendFacturaE } =
      this.contextMenuOptionsTexts
    args.cancel = true
    if (args.item.text === editItem || args.item.text === lookItem) {
      trackEvent(TrackerEvents.EDIT_INVOICE)
      this.invoiceRedirect(selectedRegister)
    } else if (args.item.text === removeItem) {
      this.onRemoveInvoice(selectedRegister)
    } else if (args.item.text === openWindow) {
      trackEvent(TrackerEvents.EDIT_INVOICE)
      if (this.isPortalUser) {
        this.idEntity = selectedRegister.idInvoice
        this.idEntityType = selectedRegister.idEntity
        if (this.hasCompanyTemplateInvoice) {
          this.showTemplateDialog = this.checkIfOnlyOneInvoice(this.idEntity, this.idEntityType)
        } else {
          const entityAlias = this.getEntityAlias(this.idEntityType)
          this.printInvoiceOld(this.idEntity, entityAlias)
        }
      } else {
        this.invoiceRedirect(selectedRegister, '_blank')
      }
    } else if (args.item && args.item.text === viewActionsAssociated) {
      this.showCustomDialogAction({
        name: CustomDialogComponentName.VIEW_INVOICE_ACTIONS,
        styles: {
          maxWidth: '1000px',
          maxHeight: '600px'
        },
        props: {
          selectedRegister: {
            id: selectedRegister[entityKeyFields.invoices.id],
            description: selectedRegister.numberInvoice
          }
        }
      })
    } else if (args.item && args.item.text === sendFacturaE) {
      this.renderNewFacturaEDialog()
    }
  }

  generateTemplateDialog(templateSelected: any) {
    this.printInvoice(templateSelected, this.idEntity, this.idEntityType, ComponentWhereIsRendered.TABS_VIEW)
  }

  async onRemoveInvoice(selectedRegister: any) {
    await this.createEntity({
      entityType: selectedRegister.idEntity,
      idEntity: selectedRegister[entityKeyFields.invoices.id],
      context: this.invoiceContext
    })

    await this.saveSelectedRegisterId({
      id: selectedRegister[entityKeyFields.invoices.id],
      context: this.invoiceContext
    })

    switch (selectedRegister.idEntity) {
      case InvoiceEntityId.ORDER_FORMS:
        this.showRemoveDialog(this.$t('components.expedient_economic_data.order_form_delete').toString(), true)
        break
      case InvoiceEntityId.PROVISIONS:
        this.showRemoveDialog(this.$t('components.expedient_economic_data.provision_delete').toString(), true)
        break
      default:
        this.showRemoveDialog(selectedRegister.numberInvoice)
        break
    }
  }

  showRemoveDialog(text: string, isOrderFormsOrProvisions: boolean = false) {
    const message = isOrderFormsOrProvisions
      ? this.$t('components.dialog.remove_register_text_no_name', { text })
      : this.$t('components.dialog.remove_register_text', {
          text: this.$t('components.expedient_economic_data.invoice_delete'),
          register: text
        })

    this.showDialog({
      type: DialogTypes.INFO,
      message: message,
      action: this.removeInvoice,
      mainButtonText: this.$t('action_buttons.remove'),
      secondaryButtonText: this.$t('action_buttons.cancel')
    })
  }

  async removeInvoice() {
    await this.deleteInvoice({
      deleteEndpoint: this.endpoints(this.entity(this.invoiceContext).type).delete,
      listEndpoint: this.endpoints(this.entity(this.invoiceContext).type).list,
      goToURL: null,
      name: this.numberInvoice,
      dialogText: this.$t('components.dialog.invoices_literal')
    })
    await this.refreshInvoiceList()
  }

  async refreshInvoiceList() {
    await this.removeListItems()
    await this.fetchCurrentListConfiguration('listExpedientInvoices')
    await this.$store.dispatch(`expedientsModule/fetchExpedientsInvoices`, {
      selectedRegisterId: this.expedientId,
      listName: 'listExpedientsInvoices'
    })
  }

  invoiceRedirect(selectedRegister: any, target: string = 'self') {
    const urlInvoice = getUrlByIdEntity(selectedRegister.idEntity, selectedRegister.idInvoice)
    redirectTo(urlInvoice, target)
  }

  onToolbarClicked(args: any) {
    const target = args.originalEvent.target.closest('button')

    if (target && target.id === 'add') {
      this.toggleContextMenu(args.originalEvent)
      args.cancel = true
    }
  }

  toggleContextMenu(event: MouseEvent) {
    if (event) {
      const btn: EventTarget | null = event.target
      if (btn) {
        const rect: ClientRect | DOMRect = (btn as HTMLHtmlElement).getBoundingClientRect()
        const elem: any = document.getElementById('expedientInvoicesContextMenuComponent')
        if (null !== elem) {
          elem.ej2_instances[0].open(rect.top + window.scrollY + 50, rect.left + 20)
        }
      }
    }
  }

  async onInvoiceAddClick({ item }: any) {
    const { idEntity } = item
    this.trackClickAdd(idEntity)
    const urlInvoice = getUrlByIdEntity(idEntity, (this as any).$t('views.selected_register.new'))
    this.saveExpedientCustomerFact()
    redirectTo(urlInvoice)
  }

  trackClickAdd(idEntity: number) {
    if (idEntity === entity.invoices.proforma.type) {
      trackEvent(TrackerEvents.CREATE_INVOICE)
    }
    if (idEntity === entity.invoices.customers.type) {
      trackEvent(TrackerEvents.CREATE_INVOICE)
    }
  }

  saveExpedientCustomerFact() {
    const customerFactInfo = (this as any).selectedRegisterData(ContextName.EXPEDIENTS).customerfact

    if (customerFactInfo) {
      this.saveExpedientCustomerFactMutation(customerFactInfo)
    }
  }

  onCommandClick({ commandColumn, rowData }: CommandClickEventArgs) {
    const action = commandColumn?.id
    const { idEntity, idInvoice } = rowData as any
    switch (action) {
      case ActionName.REMOVE:
        this.onRemoveInvoice(rowData)
        break
      case ActionName.OPEN_NEW_TAB:
        if (this.isPortalUser) {
          this.idEntity = idInvoice
          this.idEntityType = idEntity
          if (this.hasCompanyTemplateInvoice) {
            this.showTemplateDialog = this.checkIfOnlyOneInvoice(this.idEntity, this.idEntityType)
          } else {
            const entityAlias = this.getEntityAlias(this.idEntityType)
            this.printInvoiceOld(this.idEntity, entityAlias)
          }
        } else {
          this.invoiceRedirect({ idInvoice, idEntity }, '_blank')
        }
        break
    }
  }

  async closeFacturaEDialog(hasValidatorErrors: boolean) {
    this.showFacturaEDialog = false
    if (!hasValidatorErrors) {
      await this.refreshInvoiceList()
    }
  }

  renderNewFacturaEDialog(): void {
    if (isNaN(this.getSelectedInvoiceId)) {
      this.showDialogAction({
        type: DialogTypes.WARNING,
        message: this.$t('components.dialog.facturae_missing'),
        mainButtonText: this.$t('action_buttons.accept')
      })
      return
    }

    this.showDialogAction({
      type: DialogTypes.INFO,
      message: this.$t('components.dialog.facturae_prompt', { description: this.getSelectedInvoiceDescription }),
      action: async () => {
        this.facturaEDialogKey += 1
        this.showFacturaEDialog = true
      },
      mainButtonText: this.$t('action_buttons.issue_and_send'),
      secondaryButtonText: this.$t('action_buttons.cancel')
    })
  }
}
</script>
<style lang="scss" scoped>
.expedient-invoices {
  .tab-header-container {
    border: none;
    margin-bottom: 0;
    padding-bottom: 0;
  }
}
</style>
